<template>
  <!-- Prismic field: promo_tab_label controls the button text -->
  <button
    class="fixed z-50 bg-primary text-white text-xs font-semibold uppercase tracking-widest rounded-r focus:outline-none cursor-pointer"
    style="top: 50%; left: 0; padding: 12px 8px; writing-mode: vertical-lr; transform: translateY(-50%);"
    :aria-label="`Open ${label} prompt`"
    @click="$emit('click')"
  >{{ label }}</button>
</template>

<script>
  export default {
    props: {
      // Prismic field: promo_tab_label (Key Text)
      // Description: Text shown on the sticky tab. Change per campaign.
      label: {
        type: String,
        default: 'Feedback',
      },
    },
  }
</script>
